import React from 'react';
import Service from '../service';
import { useNavigate } from 'react-router-dom';

const api = Service.getInstance();

const AuthContext = React.createContext({
    user: null,
    token: null,
    setUser: () => { },
    setToken: () => { },
});

export const AuthProvider = ({ children }) => {

    const [user, setUser] = React.useState({})
    const [token, _setToken] = React.useState(localStorage.getItem("access_token"));
    const nagigate = useNavigate();

    const setToken = (token) => {
        _setToken(token);
        localStorage.setItem('access_token', token);
    }

    const logout = async () => {

        try {
            await api.get('logout');
            setToken(null);
            localStorage.removeItem("access_token");
        } catch (error) {
            setToken(null);
            localStorage.removeItem("access_token");
        }  finally {
            nagigate('/');
        }

    }

    let value = { user, authenticated: !!token, setUser, setToken, logout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;

}

export const useStateContext = () => React.useContext(AuthContext);